import React, { ReactChild, useContext, useMemo, useRef } from "react";
import style from "./index.module.scss";
import { Button, Col, Popover, Row, Tooltip } from "antd";
import classNames from "classnames";
import { SourceItem } from "../../../../pages/ResourcePool/service";
import { Can } from "../../../../service/service";
import TagStatus from "./Components/TagStatus";
import DeleteConfirm from "../../../DeleteConfirm";
import Statics from "./Components/Statics";
import qs from "qs";
import { CourseContext } from "../../../../pages/CourseDetail/Store";
import { useHistory } from "react-router-dom";
import SourceInfo from "./Components/SourceInfo";
import { HaveWeekTime } from "../../../../service/course";
import { CourseWareTypeList } from "../../../../utils/common";

interface ListItemProps {
    source: SourceItem;
    onPublicChange?: (id: string, isPublic: Can) => void;
    onProjection?: (id: number) => void;
    onDelete?: (sourceId: number) => void;
    onDownload?: (sourceId: number) => void;
    onReName?: (sourceName: string, sourceId: number) => void;
    onEdit?: (source: SourceItem) => void;
    onPrev?: (id: number) => void;
    model?: "screencast" | "page" | "res";
    className?: string;
}

export default function ListItemV2({
    onDelete,
    onDownload,
    onProjection,
    onReName,
    onPrev,
    source,
    onEdit,
    model = "page",
    onPublicChange,
    className
}: ListItemProps) {
    type keyType = keyof typeof CourseWareTypeList;
    const ref = useRef<HTMLDivElement>(null);
    const fileType = useMemo((): string => {
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    source?.sourceFileEntity?.fileType?.toLowerCase()
                )
            ) {
                return type;
            }
        }
        return "";
    }, []);

    function isPage(children: ReactChild) {
        if (model === "page") {
            return children;
        }
    }

    function isCast(children: ReactChild) {
        if (model === "screencast") {
            return children;
        }
    }

    const popover = (
        <div className={style.popover}>
            <DeleteConfirm
                title={`确定删除吗？`}
                content={`课件名称：${source?.sourceFileEntity?.fileName}`}
                onSuccess={() => {
                    onDelete?.(source?.id);
                }}>
                <button>删除</button>
            </DeleteConfirm>
            <Button
                className={style.rebtn}
                onClick={() =>
                    onReName?.(
                        source?.sourceFileEntity?.fileName,
                        source?.sourceFileEntity.id
                    )
                }>
                重命名
            </Button>
            <Button className={style.rebtn} onClick={() => onEdit?.(source)}>
                设置
            </Button>
            {!["polyv", "href", "mp4", "video"].includes(fileType) && (
                <Button
                    className={style.rebtn}
                    type="link"
                    target="_blank"
                    href={`${
                        source.sourceFileEntity.viewUrl
                    }?attname=${encodeURIComponent(
                        source.sourceFileEntity.fileName
                    )}`}>
                    下载
                </Button>
            )}
            {source?.isPublish === Can.yes && (
                <DeleteConfirm
                    title="确定取消发布课件吗？"
                    content="取消发布课件后，学习统计数据将会被清空，请谨慎操作。"
                    onSuccess={() => {
                        onPublicChange?.(source?.id.toString(), Can.no);
                    }}>
                    <button>取消发布</button>
                </DeleteConfirm>
            )}
        </div>
    );

    //点击统计
    const { basename } = useContext(CourseContext);
    const history = useHistory();

    function onStatics(params: { status: string }) {
        const query = params ? "?" + qs.stringify(params) : "";
        history.push(`${basename}/resource/${source?.id}${query}`);
    }

    function titleClick() {
        if (["href", "polyv"].includes(fileType)) {
            window.open(source.sourceFileEntity.viewUrl);
        } else {
            onPrev?.(source?.id);
        }
    }
    function projectionClick() {
        if (["href", "polyv"].includes(fileType)) {
            window.open(source.sourceFileEntity.viewUrl);
        } else {
            onProjection?.(source?.id);
        }
    }

    return (
        <div
            className={classNames(style.root, style[fileType], className)}
            ref={ref}>
            <Row
                type="flex"
                align="middle"
                justify="space-between"
                style={{ height: "100%" }}>
                <Col span={12} className={style.left}>
                    <div className={style.titleRow}>
                        <h1 className={style.title}>
                            <Tooltip title={source?.sourceFileEntity?.fileName}>
                                <span
                                    onClick={titleClick}
                                    className={style.over}>
                                    {source?.sourceFileEntity?.fileName}
                                </span>
                            </Tooltip>
                        </h1>
                        {isPage(<TagStatus state={source?.isPublish} />)}
                    </div>

                    <SourceInfo source={source} />
                </Col>
                <Col>
                    <div className={style.tools}>
                        {model !== "res" &&
                            source.weektimeId !== HaveWeekTime.no &&
                            !["polyv", "href", "compression"].includes(
                                fileType
                            ) && (
                                <Button
                                    type="link"
                                    className={classNames(style.button)}
                                    onClick={projectionClick}>
                                    快速投屏
                                </Button>
                            )}

                        {source?.isPublish === Can.no &&
                            isPage(
                                <Button
                                    type="link"
                                    className={classNames(style.button)}
                                    onClick={() => {
                                        onPublicChange?.(
                                            source?.id.toString(),
                                            Can.yes
                                        );
                                    }}>
                                    发布
                                </Button>
                            )}

                        {source?.isPublish === Can.yes &&
                            isPage(
                                <Statics
                                    totalNumber={
                                        source?.dcCoursewareSourceStatics
                                            ?.totalNumber
                                    }
                                    hasLearnNumber={
                                        source?.dcCoursewareSourceStatics
                                            ?.hasLearnNumber
                                    }
                                    notLearnNumber={
                                        source?.dcCoursewareSourceStatics
                                            ?.notLearnNumber
                                    }
                                    onClick={onStatics}
                                />
                            )}

                        {isPage(
                            <Popover
                                content={popover}
                                placement="bottom"
                                overlayClassName={style.popoverWrapper}
                                getPopupContainer={() => ref.current!}>
                                <button
                                    className={classNames(
                                        style.button,
                                        style.more
                                    )}
                                />
                            </Popover>
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    );
}
